import {
  fetchInstrumentDetails,
  searchProducts,
  fetchInstruments,
  fetchDividends,
  fetchNews,
  openInstrument,
  openInstrumentNews,
  searchProductLibrary
} from './actions';
import { fetchEsg } from './esgActions';

import { actions } from './store';

export const instrumentActions = {
  fetchInstrumentDetails,
  fetchInstruments,
  searchProducts,
  fetchDividends,
  fetchNews,
  fetchEsg,
  exchangeFetched: actions.exchangeFetched,
  openInstrument,
  openInstrumentNews,
  searchProductLibrary
};
export { INSTRUMENT_API_NAMES } from './actions';
export * from './hooks';
export { createInstrumentStore, defaultInstrumentStore, INSTRUMENT_STORE_NAME } from './store';
export * from './types';
